import { render, staticRenderFns } from "./PopoverPatientSearchResults.vue?vue&type=template&id=52ab709b&scoped=true"
import script from "./PopoverPatientSearchResults.vue?vue&type=script&lang=js"
export * from "./PopoverPatientSearchResults.vue?vue&type=script&lang=js"
import style0 from "./PopoverPatientSearchResults.vue?vue&type=style&index=0&id=52ab709b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ab709b",
  null
  
)

export default component.exports